<template>
  <div class="page_toolManage">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px" size="small">
            <el-form-item label="关键词" size="small">
              <el-input v-model="listQuery.keyword" placeholder="编码/名称/描述" size="small" clearable style="width:200px"></el-input>
            </el-form-item>
            <el-form-item label="状态" size="small">
              <el-select v-model="listQuery.status" placeholder="" clearable size="small" style="width:140px">
                <el-option v-for="(name, idx) in statusNames" :key="idx" :label="name" :value="idx"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-button v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>AI 工作台</el-breadcrumb-item>
          <el-breadcrumb-item>工具管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="createTool">+ 新建工具</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column key="code" label="编码" min-width="140" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}"><strong>#{{ row.id }}</strong><br><small>{{ row.code }}</small></template>
          </el-table-column>
          <el-table-column key="name" prop="name" label="名称" min-width="140" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}"><strong>{{ row.name }}</strong><br><small>{{ row.description }}</small></template>
          </el-table-column>
          <el-table-column key="toolType" label="类型" min-width="100" align="center">
            <template slot-scope="{row}">{{ typeNames[row.toolType] || row.toolType }}<br><small>{{ row.category || '未分类' }}</small></template>
          </el-table-column>
          <el-table-column key="status" label="状态" min-width="90" align="center">
            <template slot-scope="{row}">
              <el-tag :type="statusTagType(row.status)" size="mini">{{ statusNames[row.status] }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column key="updateTime" label="更新时间" min-width="160" align="center">
            <template slot-scope="{row}">{{ formatTime(row.updateTime) }}</template>
          </el-table-column>
          <el-table-column key="action" label="操作" fixed="right" align="center" width="220">
            <template slot-scope="{row}">
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="showDetail(row.id)">版本与配置</el-button>
                <el-button type="text" size="small" @click="editTool(row)">编辑</el-button>
                <el-popconfirm v-if="row.status === 0 && !row.isSystem" title="确定删除该工具？" @confirm="removeTool(row)" style="margin-left:10px">
                  <el-button type="text" size="small" slot="reference">删除</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount > 0" @current-change="currentChange" :current-page.sync="listQuery.pagination.page" :page-size="Number(listQuery.pagination.pageSize)" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 新建/编辑工具 -->
    <el-dialog :title="editingTool ? '编辑工具' : '创建工具'" :visible.sync="editorOpen" width="800px" class="res_dialog" :close-on-click-modal="false">
      <el-form ref="toolForm" :model="form" :rules="rules" label-width="120px" size="small">
        <el-form-item label="工具编码" prop="code"><el-input v-model="form.code" style="width:300px"></el-input></el-form-item>
        <el-form-item label="显示名称" prop="name"><el-input v-model="form.name" style="width:300px"></el-input></el-form-item>
        <el-form-item label="分类"><el-input v-model="form.category" placeholder="CRM / 数据 / 流程" style="width:300px"></el-input></el-form-item>
        <el-form-item label="工具类型" prop="toolType">
          <el-select v-model="form.toolType" style="width:200px">
            <el-option v-for="(name, id) in typeNames" :key="id" :label="name" :value="Number(id)"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用途说明" prop="description"><el-input v-model="form.description" style="width:500px"></el-input></el-form-item>
        <template v-if="!editingTool">
          <el-form-item label="初始版本"><el-input v-model="form.version" style="width:200px"></el-input></el-form-item>
          <el-form-item label="函数名称"><el-input v-model="form.functionName" placeholder="query_customer" style="width:300px"></el-input></el-form-item>
          <el-form-item label="版本描述"><el-input v-model="form.versionDescription" style="width:500px"></el-input></el-form-item>
          <el-form-item label="模型调用说明"><el-input v-model="form.usageInstructions" type="textarea" :rows="4" placeholder="调用时机、前置条件、确认要求和限制规则" style="width:560px"></el-input></el-form-item>
          <el-form-item label="操作类型">
            <el-select v-model="form.operationType" style="width:200px">
              <el-option :value="0" label="只读"></el-option>
              <el-option :value="1" label="写入"></el-option>
              <el-option :value="2" label="高风险写入"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="执行策略">
            <el-checkbox v-model="form.requiresConfirmation" :disabled="form.operationType === 2">执行前要求用户确认</el-checkbox>
            <el-checkbox v-model="form.idempotencyEnabled" :disabled="form.operationType === 2">启用平台防重复执行</el-checkbox>
          </el-form-item>
          <el-form-item label="输入 JSON Schema"><el-input v-model="form.inputSchema" type="textarea" :rows="6" style="width:560px;font-family:Consolas,monospace"></el-input></el-form-item>
          <el-form-item label="输出 JSON Schema"><el-input v-model="form.outputSchema" type="textarea" :rows="4" placeholder="可空" style="width:560px;font-family:Consolas,monospace"></el-input></el-form-item>
          <el-form-item label="协议">
            <el-select v-model="form.protocol" style="width:200px" @change="onProtocolChange">
              <el-option label="HTTP" value="HTTP"></el-option>
              <el-option label="SERVICE" value="SERVICE"></el-option>
              <el-option label="SQL" value="SQL"></el-option>
              <el-option label="MCP" value="MCP"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="超时/重试">
            <el-input-number v-model="form.timeoutSeconds" :min="1" size="small" style="width:120px"></el-input-number>
            <el-input-number v-model="form.retryCount" :min="0" size="small" style="margin-left:10px;width:120px"></el-input-number>
          </el-form-item>
          <el-form-item label="调用配置 JSON">
            <el-input v-model="form.config" type="textarea" :rows="7" style="width:560px;font-family:Consolas,monospace"></el-input>
            <el-button v-if="form.protocol === 'MCP'" type="text" size="mini" @click="inspectMcp(form.config)" style="margin-left:10px">测试 MCP</el-button>
          </el-form-item>
        </template>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editorOpen = false" size="small">取消</el-button>
        <el-button type="primary" @click="saveTool" :loading="saving" size="small">保存</el-button>
      </span>
    </el-dialog>

    <!-- 工具详情（版本与配置） -->
    <el-dialog :title="selected ? selected.tool.name : '工具详情'" :visible.sync="detailOpen" width="900px" class="res_dialog" :close-on-click-modal="false">
      <template v-if="selected">
        <div style="margin-bottom:10px;color:#909399;font-size:13px">{{ selected.tool.code }} · {{ typeNames[selected.tool.toolType] }}</div>
        <div class="section-heading">
          <strong>版本</strong>
          <el-button type="primary" size="mini" @click="createVersion">+ 新版本</el-button>
        </div>
        <div v-for="v in selected.versions" :key="v.id" class="version-card">
          <div>
            <el-tag :type="versionStatusType(v.status)" size="mini">{{ versionStatusNames[v.status] }}</el-tag>
            <strong style="margin-left:8px">{{ v.version }}</strong>
            <small style="margin-left:8px">{{ v.functionName }}</small>
            <p style="margin:5px 0">{{ v.description }}</p>
            <small>{{ ['只读','写入','高风险写入'][v.operationType] }} · {{ v.requiresConfirmation ? '需要确认' : '无需确认' }} · {{ v.idempotencyEnabled ? '防重复已启用' : '防重复未启用' }}</small><br>
            <small>{{ v.invokeConfig ? v.invokeConfig.protocol : '未配置调用方式' }} · 超时 {{ v.timeoutSeconds }}s · 重试 {{ v.retryCount }}</small>
          </div>
          <div class="version-actions">
            <el-button type="text" size="mini" @click="editConfig(v)">调用配置</el-button>
            <el-button v-if="v.status === 0" type="text" size="mini" @click="editVersion(v)">编辑</el-button>
            <el-button v-if="v.status === 0" type="text" size="mini" @click="publishVersion(v)">发布</el-button>
            <el-popconfirm v-if="v.status === 0" title="确定删除该版本？" @confirm="removeVersion(v)" style="margin-left:5px">
              <el-button type="text" size="mini" slot="reference">删除</el-button>
            </el-popconfirm>
          </div>
        </div>
        <div v-if="!selected.versions.length" style="color:#909399;padding:20px 0">暂无版本</div>
        <div class="section-heading" style="margin-top:20px">
          <strong>权限编码</strong>
        </div>
        <el-input v-model="permissionsText" type="textarea" :rows="3" placeholder="每行或逗号分隔" style="font-family:Consolas,monospace"></el-input>
        <el-button type="success" size="mini" @click="savePermissions" style="margin-top:5px">保存权限</el-button>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailOpen = false" size="small">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 版本编辑 -->
    <el-dialog :title="editingVersion ? '编辑草稿版本' : '创建工具版本'" :visible.sync="versionOpen" width="780px" class="res_dialog" :close-on-click-modal="false" append-to-body>
      <el-form ref="versionForm" :model="versionForm" label-width="120px" size="small">
        <el-form-item label="版本号"><el-input v-model="versionForm.version" style="width:200px"></el-input></el-form-item>
        <el-form-item label="函数名称"><el-input v-model="versionForm.functionName" style="width:300px"></el-input></el-form-item>
        <el-form-item label="模型可见描述"><el-input v-model="versionForm.description" style="width:500px"></el-input></el-form-item>
        <el-form-item label="模型调用说明"><el-input v-model="versionForm.usageInstructions" type="textarea" :rows="4" style="width:560px"></el-input></el-form-item>
        <el-form-item label="操作类型">
          <el-select v-model="versionForm.operationType" style="width:200px">
            <el-option :value="0" label="只读"></el-option>
            <el-option :value="1" label="写入"></el-option>
            <el-option :value="2" label="高风险写入"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="执行策略">
          <el-checkbox v-model="versionForm.requiresConfirmation" :disabled="versionForm.operationType === 2">执行前要求用户确认</el-checkbox>
          <el-checkbox v-model="versionForm.idempotencyEnabled" :disabled="versionForm.operationType === 2">启用平台防重复执行</el-checkbox>
        </el-form-item>
        <el-form-item label="超时秒数"><el-input-number v-model="versionForm.timeoutSeconds" :min="1" size="small"></el-input-number></el-form-item>
        <el-form-item label="重试次数"><el-input-number v-model="versionForm.retryCount" :min="0" size="small"></el-input-number></el-form-item>
        <el-form-item label="输入 JSON Schema"><el-input v-model="versionForm.inputSchema" type="textarea" :rows="6" style="width:560px;font-family:Consolas,monospace"></el-input></el-form-item>
        <el-form-item label="输出 JSON Schema"><el-input v-model="versionForm.outputSchema" type="textarea" :rows="4" style="width:560px;font-family:Consolas,monospace"></el-input></el-form-item>
        <el-form-item label="变更说明"><el-input v-model="versionForm.changelog" style="width:500px"></el-input></el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="versionOpen = false" size="small">取消</el-button>
        <el-button type="primary" @click="saveVersion" size="small">保存版本</el-button>
      </span>
    </el-dialog>

    <!-- 调用配置 -->
    <el-dialog title="调用配置" :visible.sync="configOpen" width="780px" class="res_dialog" :close-on-click-modal="false" append-to-body>
      <el-form :model="configForm" label-width="120px" size="small">
        <el-form-item label="协议">
          <el-select v-model="configForm.protocol" style="width:200px">
            <el-option label="HTTP" value="HTTP"></el-option>
            <el-option label="SERVICE" value="SERVICE"></el-option>
            <el-option label="SQL" value="SQL"></el-option>
            <el-option label="MCP" value="MCP"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="启用调用配置"><el-checkbox v-model="configForm.enabled"></el-checkbox></el-form-item>
        <el-form-item label="配置 JSON">
          <el-input v-model="configForm.config" type="textarea" :rows="12" style="font-family:Consolas,monospace"></el-input>
          <el-button v-if="configForm.protocol === 'MCP'" type="text" size="mini" @click="inspectMcp()" style="margin-top:5px">测试 MCP 并发现工具</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="configOpen = false" size="small">取消</el-button>
        <el-button type="primary" @click="saveConfig" size="small">保存配置</el-button>
      </span>
    </el-dialog>

    <!-- MCP 检测结果 -->
    <el-dialog title="MCP 连接与工具发现" :visible.sync="mcpOpen" width="600px" class="res_dialog" :close-on-click-modal="false" append-to-body>
      <div v-if="!mcpResult" style="color:#909399;padding:20px 0">正在连接 MCP Server…</div>
      <div v-else-if="!mcpResult.connected" style="color:#f56c6c">{{ mcpResult.errorMessage }}</div>
      <template v-else>
        <div style="margin-bottom:10px"><strong>{{ mcpResult.serverName || 'MCP Server' }}</strong> · {{ mcpResult.serverVersion || '未知版本' }} · {{ mcpResult.tools.length }} 个工具</div>
        <div v-for="tool in mcpResult.tools" :key="tool.name" style="margin-bottom:12px;padding:8px;border:1px solid #ebeef5;border-radius:4px">
          <strong>{{ tool.title || tool.name }}</strong>
          <code style="display:block;margin:3px 0">{{ tool.name }}</code>
          <p style="font-size:13px;color:#606266">{{ tool.description || '暂无描述' }}</p>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mcpOpen = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  export default {
    data() {
      return {
        typeNames: { 1: 'HTTP', 2: 'SERVICE', 3: 'SQL', 4: 'WORKFLOW', 5: 'MCP' },
        statusNames: ['草稿', '已发布', '禁用', '已下线'],
        versionStatusNames: ['测试', '已发布', '已废弃'],
        listQuery: { keyword: '', status: null, pagination: { page: 1, pageSize: 10 } },
        tableData: [],
        totalCount: 0,
        loading: false,
        editorOpen: false,
        detailOpen: false,
        versionOpen: false,
        configOpen: false,
        mcpOpen: false,
        editingTool: false,
        editingVersion: null,
        selected: null,
        saving: false,
        mcpResult: null,
        permissionsText: '',
        form: this.emptyTool(),
        versionForm: this.emptyVersion(),
        configForm: { toolVersionId: 0, protocol: 'HTTP', config: '{}', enabled: true },
        rules: {
          code: [{ required: true, message: '请输入工具编码', trigger: 'blur' }],
          name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
          description: [{ required: true, message: '请输入说明', trigger: 'blur' }]
        }
      }
    },
    created() {
      this.load();
    },
    methods: {
      emptyTool() {
        return {
          id: 0, tenantId: 0, code: '', name: '', description: '', category: '',
          toolType: 1, isSystem: false, operatorUserId: 1,
          version: 'v1', functionName: '', versionDescription: '', usageInstructions: '',
          operationType: 0, requiresConfirmation: false, idempotencyEnabled: false,
          inputSchema: '{\n  "type": "object",\n  "properties": {}\n}', outputSchema: null,
          timeoutSeconds: 30, retryCount: 0, changelog: '初始版本',
          protocol: 'HTTP', config: this.httpExample(), configEnabled: true, permissions: []
        }
      },
      emptyVersion() {
        return {
          id: 0, toolId: 0, version: 'v2', functionName: '', description: '', usageInstructions: '',
          operationType: 0, requiresConfirmation: false, idempotencyEnabled: false,
          inputSchema: '{\n  "type": "object",\n  "properties": {}\n}', outputSchema: null,
          timeoutSeconds: 30, retryCount: 0, changelog: '', operatorUserId: 1
        }
      },
      httpExample() {
        return '{\n  "url": "https://example.com/api/{{id}}",\n  "method": "GET",\n  "allowedHosts": ["example.com"],\n  "idempotencyHeader": "Idempotency-Key"\n}';
      },
      configExample(protocol) {
        if (protocol === 'MCP') return '{\n  "endpoint": "https://example.com/mcp",\n  "allowedHosts": ["example.com"],\n  "transportMode": "AutoDetect",\n  "idempotencyMetaKey": "idempotencyKey"\n}';
        if (protocol === 'SQL') return '{\n  "connectionId": "default",\n  "statement": "SELECT * FROM example WHERE id = @id",\n  "parameters": { "id": "id" },\n  "maxRows": 100\n}';
        if (protocol === 'SERVICE') return '{}';
        return this.httpExample();
      },
      formatTime(val) {
        return val ? new Date(val).toLocaleString('zh-CN', { hour12: false }) : '—';
      },
      statusTagType(val) {
        if (val === 1) return 'success';
        if (val === 2) return 'danger';
        if (val === 3) return 'info';
        return 'warning';
      },
      versionStatusType(val) {
        if (val === 1) return 'success';
        if (val === 2) return 'info';
        return 'warning';
      },
      currentChange(val) {
        this.listQuery.pagination.page = Number(val);
        this.load();
      },
      handleSizeChange(val) {
        this.listQuery.pagination.page = 1;
        this.listQuery.pagination.pageSize = val;
        this.load();
      },
      searchHandle() {
        this.listQuery.pagination.page = 1;
        this.load();
      },
      load() {
        this.loading = true;
        xz.getToolPage(this.listQuery).then(res => {
          if (res) {
            this.tableData = res.data || [];
            this.totalCount = res.totalCount || 0;
          } else {
            this.tableData = [];
            this.totalCount = 0;
          }
          this.loading = false;
        }).catch(() => {
          this.tableData = [];
          this.totalCount = 0;
          this.loading = false;
        });
      },
      createTool() {
        this.editingTool = false;
        this.form = this.emptyTool();
        this.editorOpen = true;
        this.$nextTick(() => { this.$refs.toolForm && this.$refs.toolForm.clearValidate(); });
      },
      editTool(row) {
        xz.getToolDetail(row.id).then(res => {
          if (res && res.tool) {
            this.editingTool = true;
            this.selected = res;
            this.form = Object.assign(this.emptyTool(), res.tool, { operatorUserId: 1 });
            this.editorOpen = true;
            this.$nextTick(() => { this.$refs.toolForm && this.$refs.toolForm.clearValidate(); });
          } else {
            this.$message.error('获取详情失败');
          }
        });
      },
      onProtocolChange(val) {
        if (this.form.config === '{}' || this.form.config === this.configExample(val === 'HTTP' ? 'MCP' : 'HTTP')) {
          this.form.config = this.configExample(val);
        }
      },
      saveTool() {
        this.$refs.toolForm.validate(valid => {
          if (!valid) return;
          this.saving = true;
          let payload = Object.assign({}, this.form);
          payload.id = Number(payload.id);
          payload.tenantId = Number(payload.tenantId);
          payload.toolType = Number(payload.toolType);
          payload.timeoutSeconds = Number(payload.timeoutSeconds);
          payload.retryCount = Number(payload.retryCount);
          payload.operatorUserId = Number(Cookies.get("userid-b")) || 1;
          let req = this.editingTool ? xz.updateTool(payload) : xz.createTool(payload);
          req.then(res => {
            this.saving = false;
            if (res !== false) {
              this.$message.success(this.editingTool ? '工具已保存' : '工具已创建');
              this.editorOpen = false;
              this.load();
            } else {
              this.$message.error('保存失败');
            }
          }).catch(() => { this.saving = false; });
        });
      },
      removeTool(row) {
        xz.deleteTool(row.id).then(res => {
          if (res !== false) {
            this.$message.success('工具已删除');
            this.load();
          } else {
            this.$message.error('删除失败');
          }
        });
      },
      async showDetail(id) {
        try {
          this.selected = await xz.getToolDetail(id);
          this.permissionsText = (this.selected && this.selected.permissions || []).join('\n');
          this.detailOpen = true;
        } catch (e) {
          this.$message.error('获取详情失败');
        }
      },
      async refreshDetail() {
        if (this.selected) {
          this.selected = await xz.getToolDetail(this.selected.tool.id);
          this.permissionsText = (this.selected.permissions || []).join('\n');
        }
      },
      createVersion() {
        this.editingVersion = null;
        this.versionForm = Object.assign(this.emptyVersion(), {
          toolId: this.selected.tool.id,
          functionName: (this.selected.versions[0] && this.selected.versions[0].functionName) || (this.selected.tool.code || '').replaceAll('-', '_')
        });
        this.versionOpen = true;
      },
      editVersion(version) {
        this.editingVersion = version;
        this.versionForm = Object.assign(this.emptyVersion(), version, { operatorUserId: 1 });
        this.versionOpen = true;
      },
      saveVersion() {
        let payload = Object.assign({}, this.versionForm);
        payload.id = Number(payload.id);
        payload.toolId = Number(payload.toolId);
        payload.timeoutSeconds = Number(payload.timeoutSeconds);
        payload.retryCount = Number(payload.retryCount);
        let req = this.editingVersion ? xz.updateToolVersion(payload) : xz.createToolVersion(payload);
        req.then(async res => {
          if (res !== false) {
            this.versionOpen = false;
            await this.refreshDetail();
            this.$message.success('工具版本已保存');
          } else {
            this.$message.error('保存失败');
          }
        });
      },
      async removeVersion(version) {
        let res = await xz.deleteToolVersion(this.selected.tool.id, version.id);
        if (res !== false) {
          await this.refreshDetail();
          this.$message.success('版本已删除');
        } else {
          this.$message.error('删除失败');
        }
      },
      async publishVersion(version) {
        let res = await xz.publishToolVersion(this.selected.tool.id, version.id);
        if (res !== false) {
          await this.refreshDetail();
          this.load();
          this.$message.success('版本发布成功');
        } else {
          this.$message.error('发布失败');
        }
      },
      editConfig(version) {
        let protocol = (version.invokeConfig && version.invokeConfig.protocol) || this.typeNames[this.selected.tool.toolType] || 'HTTP';
        let config = (version.invokeConfig && version.invokeConfig.config) || this.configExample(protocol);
        let enabled = (version.invokeConfig && version.invokeConfig.enabled !== undefined) ? version.invokeConfig.enabled : true;
        this.configForm = { toolVersionId: version.id, protocol, config, enabled };
        this.configOpen = true;
      },
      saveConfig() {
        xz.saveToolInvokeConfig(Object.assign({}, this.configForm, { toolVersionId: Number(this.configForm.toolVersionId) })).then(async res => {
          if (res !== false) {
            this.configOpen = false;
            await this.refreshDetail();
            this.$message.success('调用配置已保存');
          } else {
            this.$message.error('保存失败');
          }
        });
      },
      savePermissions() {
        let values = [...new Set(this.permissionsText.split(/[\n,]/).map(x => x.trim()).filter(Boolean))];
        xz.saveToolPermissions(this.selected.tool.id, values).then(res => {
          if (res !== false) {
            this.selected.permissions = values;
            this.$message.success('权限编码已保存');
          } else {
            this.$message.error('保存失败');
          }
        });
      },
      async inspectMcp(config) {
        this.mcpResult = null;
        this.mcpOpen = true;
        try {
          this.mcpResult = await xz.inspectMcp({ config: config || this.configForm.config, timeoutSeconds: 15 });
        } catch (e) {
          this.mcpResult = { connected: false, errorMessage: e.message, tools: [] };
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }
  .ftabBtn {
    padding: 10px 0;
  }
  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }
  .section-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 15px 0 8px;
  }
  .version-card {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 12px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    margin-bottom: 8px;
  }
  .version-actions {
    display: flex;
    flex-direction: column;
    gap: 4px;
    text-align: right;
  }
</style>
<style>
  .page_toolManage .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }
  .page_toolManage .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }
  .page_toolManage .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>
